import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs/internal/Subject';

import { PeopleService } from '@app/core/services/people.service';
import { StudentClass } from '@df/interfaces';

@Component({
    selector: 'app-class-list',
    templateUrl: './class-list.component.html',
    styleUrls: ['./class-list.component.scss']
})
export class ClassListComponent implements OnInit, OnDestroy {
    public classes: Array<StudentClass>;
    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private peopleService: PeopleService) {}

    ngOnInit(): void {
        localStorage.clear();
        sessionStorage.clear();

        this.peopleService.getClasses().subscribe(resp => {
            this.classes = resp.results;
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
    }
}
